var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThinborder3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1038_6106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M736.572 -503.32H22.7399C22.3266 -503.32 21.9625 -503.054 21.8248 -502.661C18.4989 -492.732 10.5877 -484.82 0.65927 -481.494C0.265676 -481.366 0 -480.992 0 -480.579V1.25861C0 1.67191 0.265676 2.03601 0.65927 2.17377C10.5877 5.49986 18.4989 13.4116 21.8248 23.3407C21.9527 23.7343 22.3266 24 22.7399 24H736.572C736.985 24 737.349 23.7343 737.487 23.3407C740.813 13.4116 748.724 5.49986 758.653 2.17377C759.046 2.04585 759.312 1.67191 759.312 1.25861V-480.579C759.312 -480.992 759.046 -481.356 758.653 -481.494C748.724 -484.82 740.813 -492.732 737.487 -502.661C737.359 -503.054 736.985 -503.32 736.572 -503.32ZM23.4188 -501.401H735.883C739.445 -491.423 747.406 -483.462 757.373 -479.91V0.569777C747.396 4.13204 739.435 12.093 735.883 22.0713H23.4188C19.8568 12.093 11.8964 4.13204 1.91877 0.569777V-479.9C11.8964 -483.462 19.8568 -491.423 23.4188 -501.391V-501.401Z",
    fill: "#C4944D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1038_6106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThinborder3);
export default __webpack_public_path__ + "static/media/Thinborder3.d6e11fccaf7fdd41d0296db5f63b227b.svg";
export { ForwardRef as ReactComponent };